// Inject CSS to hide Shopify chat when cart drawer is open
(function() {
    if (!document.getElementById('cart-chat-hide-style')) {
        const style = document.createElement('style');
        style.id = 'cart-chat-hide-style';
        style.textContent = `
            body.cart-drawer-open .chat-app,
            body.cart-drawer-open #shopify-chat,
            body.cart-drawer-open [class*="shopify-chat"],
            body.cart-drawer-open [id*="shopify-chat"],
            body.cart-drawer-open .gorgias-chat-container,
            body.cart-drawer-open #gorgias-chat-container {
                display: none !important;
                visibility: hidden !important;
                opacity: 0 !important;
                pointer-events: none !important;
            }
        `;
        document.head.appendChild(style);
    }
})();

if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);

        // Hide Shopify chat when cart drawer opens
        document.body.classList.add('cart-drawer-open');

        // 由于购物车的Dom内容会被替换，所以需要重新获取
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory && typeof recommendationByHistory.showContent === 'function') {
          recommendationByHistory.showContent();
        }
      }

      hide() {
        super.hide();

        // Show Shopify chat when cart drawer closes
        document.body.classList.remove('cart-drawer-open');

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory && typeof recommendationByHistory.abortFetch === 'function') {
          recommendationByHistory.abortFetch();
        }
      }
    },
  );
}
